import React, {useState} from 'react';
import {Box, Button, Modal} from '@mui/material';
import TagsModal from "../../../components/tagsModal";
import {tags} from "../../../utils/tags";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    minWidth: 400,
    maxWidth: 650,
    maxHeight: '80vh',
    overflowY: 'auto',
    borderRadius: 1,
};

export default function TriggerModal({visible, onClose, children}) {
    // Для модального окна тегов
    const [tagsModalOpen, setTagsModalOpen] = useState(false);
    const [copiedTag, setCopiedTag] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleCopyTag = (tag) => {
        navigator.clipboard.writeText(tag);
        setCopiedTag(tag);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    return (
        <Modal open={visible} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
            <Box sx={style} tabIndex={-1}>
                <Button
                    variant='contained'
                    onClick={() => setTagsModalOpen(true)}
                    sx={{
                        fontSize: '12px',
                        position: 'absolute',
                        top: 32,
                        right: 32,
                        zIndex: 10,
                    }}
                    aria-label="Открыть список тегов"
                >
                    Теги
                </Button>

                {children}

                <TagsModal
                    open={tagsModalOpen}
                    onClose={() => setTagsModalOpen(false)}
                    tags={tags}
                    onCopyTag={handleCopyTag}
                    copiedTag={copiedTag}
                    snackbarOpen={snackbarOpen}
                    onSnackbarClose={() => setSnackbarOpen(false)}
                />
            </Box>
        </Modal>
    );
}
